export default __webpack_public_path__ + "static/media/julia.89f5f0a6.jpg";